import * as React from "react";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  Typography,
  IconButton,
  Container,
  Menu,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import MenuIcon from "@mui/icons-material/Menu";
import Stack from "@mui/material/Stack";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ContactusForm from "../contactusmodal/Contactus";
import usersEndpoints from "../../../services/userServices";
import Logo from "../../../logo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/*global chrome*/

const pages = [
  // { name: "Pricing",      url: "/#pricing_container" },
  
  { name: "Brands", url: "/#brands_container" },
  { name: "About",        url: "/about_us" },

  { name: "Contact",      url: "/policy/contactus" },
];

function HeaderSection({
  handleShowContactForm,
  handleCloseContactForm,
  showContactForm,
  showNav,
}) {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [cookies, removeCookie] = useCookies(["user"]);
  const [user, setUser] = useState({});
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleOpenNavMenu  = (e) => setAnchorElNav(e.currentTarget);
  const handleCloseNavMenu = ()  => setAnchorElNav(null);

  useEffect(() => {
    if (!isHome) return;
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHome]);

  const handleLogout = () => {
    removeCookie("auth", "", { path: "/",      expires: new Date(1691479246) });
    removeCookie("auth", "", { path: "/filter", expires: new Date(1691479246) });
    removeCookie("user", "", { path: "/",      expires: new Date(1691479246) });
  };

  useEffect(() => {
    if (cookies.user && cookies.user !== "undefined" && cookies.user.name) {
      setLoggedIn(true);
      getUser();
    } else {
      handleLogout();
    }
  }, []);

  const getUser = async () => {
    const response = await usersEndpoints.getUserDetails();
    if (response["success"]) {
      setUser(response.user);
    } else if (response["success"] === false && response["logout"] === true) {
      toast.error("Your session has expired, Try logging in back again");
      removeCookie("auth", "", { path: "/", expires: new Date(1691479246) });
      removeCookie("user", "", { path: "/", expires: new Date(1691479246) });
      try {
        chrome.runtime.sendMessage(
          process.env.REACT_APP_EXTENSION_ID,
          { message: "logout_user" },
          (r) => { r = r || {}; }
        );
      } catch (e) { console.log(e); }
      window.location.href = "/";
    }
  };

  const handleMenuItemClick = (page) => {
    if (page.url) window.open(page.url, "_blank");
    else handleShowContactForm();
  };

  /* ── Style helpers ── */
  const isSolid  = !isHome || scrolled;
  const navBg    = isSolid ? "rgba(13,27,62,0.97)" : "transparent";
  const navBlur  = isSolid ? "blur(12px)" : "none";
  const navShadow = isSolid ? "0 2px 24px rgba(0,0,0,0.18)" : "none";
  const linkColor = "rgba(255,255,255,0.85)";

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: navBg,
          backdropFilter: navBlur,
          boxShadow: navShadow,
          transition: "background-color 0.3s ease, box-shadow 0.3s ease",
          zIndex: 1100,
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            {/* Logo */}
            <a href="/" style={{ textDecoration: "none" }}>
              <img src={Logo} style={{ width: "123px", height: "40px" }} alt="logo" />
            </a>

            {/* Mobile hamburger */}
            {showNav && (
              <Box sx={{ display: { xs: "flex", md: "none" }, marginLeft: "auto" }}>
                <IconButton size="large" onClick={handleOpenNavMenu} sx={{ color: "white" }}>
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  PaperProps={{ sx: { bgcolor: "#0D1B3E", color: "white" } }}
                >
                  {pages.map((page, i) => (
                    <MenuItem key={i} onClick={() => { handleMenuItemClick(page); handleCloseNavMenu(); }}>
                      <Typography textAlign="center" sx={{ color: "white" }}>{page.name}</Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            )}

            {/* Desktop nav links */}
            {showNav && (
              <Box sx={{ display: { xs: "none", md: "flex" }, marginLeft: "auto" }}>
                {pages.map((page, i) =>
                  page.url ? (
                    <Button
                      key={i}
                      href={page.url}
                      sx={{
                        color: linkColor,
                        textTransform: "capitalize",
                        fontSize: "0.9rem",
                        fontWeight: 600,
                        paddingY: 0,
                        "&:hover": { color: "#FF6B35" },
                      }}
                    >
                      {page.name}
                    </Button>
                  ) : (
                    <Button
                      key={i}
                      onClick={handleShowContactForm}
                      sx={{
                        color: linkColor,
                        textTransform: "capitalize",
                        fontSize: "0.9rem",
                        fontWeight: 600,
                        paddingY: 0,
                        marginRight: 2,
                        "&:hover": { color: "#FF6B35" },
                      }}
                    >
                      {page.name}
                    </Button>
                  )
                )}
              </Box>
            )}

            {/* Right-side auth buttons */}
            {loggedIn ? (
              <Stack spacing={2} direction="row" alignItems="center" sx={{ ml: 2 }}>
                <Typography component="p" fontSize="0.9rem" sx={{ color: "white" }} fontWeight={600}>
                  Hi, {cookies.user.name}
                </Typography>
                <Button
                  variant="contained"
                  endIcon={<ArrowRightAltIcon />}
                  href="/filter/influencers"
                  sx={{
                    bgcolor: "#FF6B35",
                    color: "white",
                    fontWeight: 700,
                    textTransform: "none",
                    borderRadius: "8px",
                    "&:hover": { bgcolor: "#e85520" },
                  }}
                >
                  Dashboard
                </Button>
              </Stack>
            ) : (
              <Box display="flex" alignItems="center" gap={1.5} sx={{ ml: 2 }}>
                <Button
                  href="/authenticate/signin"
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: "rgba(255,255,255,0.45)",
                    color: "white",
                    paddingX: 2.5,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": {
                      borderColor: "white",
                      bgcolor: "rgba(255,255,255,0.06)",
                    },
                  }}
                >
                  Log in
                </Button>
                <Button
                  href="/authenticate/signup"
                  variant="contained"
                  size="small"
                  sx={{
                    bgcolor: "#FF6B35",
                    color: "white",
                    paddingX: 2.5,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 700,
                    "&:hover": { bgcolor: "#e85520" },
                  }}
                >
                  Get started free
                </Button>
              </Box>
            )}
          </Toolbar>

          <Modal
            open={showContactForm}
            onClose={handleCloseContactForm}
            children={<ContactusForm userdetails={user} />}
          />
        </Container>
      </AppBar>

      <ToastContainer style={{ fontSize: "0.85rem" }} hideProgressBar autoClose={2000} />
    </>
  );
}

export default HeaderSection;
